const musicLinksValidationDE = {
    "add": {
        "release_name": {
            "required": "Veröffentlichungsname ist erforderlich"
        },
        "ean": {
            "required": "EAN/UPC ist erforderlich"
        },
        "artist_name": {
            "required": "Künstlername ist erforderlich"
        },
        "url_part1": {
            "required": "Url Teil 1 ist erforderlich"
        },
        "url_part2": {
            "required": "Url Teil 2 ist erforderlich",
            "length": "Url Teil 2 darf nicht länger als 10 Zeichen sein",
            "duplicate": "Ups! Diese URL ist bereits mit einem anderen Musiklink verknüpft. Bitte versuchen Sie eine andere URL.",
            "urlAvailable": "Url ist verfügbar",
            "urlInvalid": "Url ist ungültig"
        },
        "amazonmusic_url": {
            "required": "Amazon Music Url ist erforderlich",
            "invalid": "Bitte fügen Sie eine gültige Amazon Music Url hinzu."
        },
        "applemusic_url": {
            "required": "Apple Music Url ist erforderlich",
            "invalid": "Bitte fügen Sie eine gültige Apple Music Url hinzu."
        },
        "beatport_url": {
            "required": "Beatport Url ist erforderlich",
            "invalid": "Bitte fügen Sie eine gültige Beatport Url hinzu."
        },
        "deezer_url": {
            "required": "Deezer Url ist erforderlich",
            "invalid": "Bitte fügen Sie eine gültige Deezer Url hinzu."
        },
        "junodownload_url": {
            "required": "Junodownload Url ist erforderlich",
            "invalid": "Bitte fügen Sie eine gültige Junodownload Url hinzu."
        },
        "soundcloud_url": {
            "required": "Soundcloud Url ist erforderlich",
            "invalid": "Bitte fügen Sie eine gültige Soundcloud Url hinzu."
        },
        "spotify_url": {
            "required": "Spotify Url ist erforderlich",
            "invalid": "Bitte fügen Sie eine gültige Spotify Url hinzu."
        },
        "tidal_url": {
            "required": "Tidal Url ist erforderlich",
            "invalid": "Bitte fügen Sie eine gültige Tidal Url hinzu."
        },
        "traxsource_url": {
            "required": "Traxsource Url ist erforderlich",
            "invalid": "Bitte fügen Sie eine gültige Traxsource Url hinzu."
        },
        "youtube_url": {
            "required": "Youtube Url ist erforderlich",
            "invalid": "Bitte fügen Sie eine gültige Youtube Url hinzu."
        },
        "anghami_url": {
            "required": "Anghami Url ist erforderlich",
            "invalid": "Bitte fügen Sie eine gültige Url hinzu."
        },
        "bandcamp_url": {
            "required": "Bandcamp Url ist erforderlich",
            "invalid": "Bitte fügen Sie eine gültige Url hinzu."
        },
        "boomplay_url": {
            "required": "Boomplay Url ist erforderlich",
            "invalid": "Bitte fügen Sie eine gültige Url hinzu."
        },
        "iheartradio_url": {
            "required": "iHeartRadio Url ist erforderlich",
            "invalid": "Bitte fügen Sie eine gültige Url hinzu."
        },
        "jiosaavn_url": {
            "required": "JioSaavn Url ist erforderlich",
            "invalid": "Bitte fügen Sie eine gültige Url hinzu."
        },
        "sevendigital_url": {
            "required": "7digital Url ist erforderlich",
            "invalid": "Bitte fügen Sie eine gültige Url hinzu."
        },
        "other_url": {
            "invalid": "Bitte fügen Sie eine gültige Url hinzu."
        },
        "pvTrackName": {
            "required": "Trackname ist erforderlich"
        },
        "pvArtistName": {
            "required": "Künstlername ist erforderlich"
        }
    },
    "update": {
        "release_name": {
            "required": "Veröffentlichungsname ist erforderlich"
        },
        "ean": {
            "required": "EAN/UPC ist erforderlich"
        },
        "artist_name": {
            "required": "Künstlername ist erforderlich"
        },
        "url_part1": {
            "required": "Url Teil 1 ist erforderlich"
        },
        "url_part2": {
            "required": "Url Teil 2 ist erforderlich",
            "length": "Url Teil 2 darf nicht länger als 10 Zeichen sein",
            "duplicate": "Ups! Diese URL ist bereits mit einem anderen Musiklink verknüpft. Bitte versuchen Sie eine andere URL.",
            "urlAvailable": "Url ist verfügbar",
            "urlInvalid": "Url ist ungültig"
        },
        "amazonmusic_url": {
            "required": "Amazon Music Url ist erforderlich",
            "invalid": "Bitte fügen Sie eine gültige Amazon Music Url hinzu."
        },
        "applemusic_url": {
            "required": "Apple Music Url ist erforderlich",
            "invalid": "Bitte fügen Sie eine gültige Apple Music Url hinzu."
        },
        "beatport_url": {
            "required": "Beatport Url ist erforderlich",
            "invalid": "Bitte fügen Sie eine gültige Beatport Url hinzu."
        },
        "deezer_url": {
            "required": "Deezer Url ist erforderlich",
            "invalid": "Bitte fügen Sie eine gültige Deezer Url hinzu."
        },
        "junodownload_url": {
            "required": "Junodownload Url ist erforderlich",
            "invalid": "Bitte fügen Sie eine gültige Junodownload Url hinzu."
        },
        "soundcloud_url": {
            "required": "Soundcloud Url ist erforderlich",
            "invalid": "Bitte fügen Sie eine gültige Soundcloud Url hinzu."
        },
        "spotify_url": {
            "required": "Spotify Url ist erforderlich",
            "invalid": "Bitte fügen Sie eine gültige Spotify Url hinzu."
        },
        "tidal_url": {
            "required": "Tidal Url ist erforderlich",
            "invalid": "Bitte fügen Sie eine gültige Tidal Url hinzu."
        },
        "traxsource_url": {
            "required": "Traxsource Url ist erforderlich",
            "invalid": "Bitte fügen Sie eine gültige Traxsource Url hinzu."
        },
        "youtube_url": {
            "required": "Youtube Url ist erforderlich",
            "invalid": "Bitte fügen Sie eine gültige Youtube Url hinzu."
        },
        "anghami_url": {
            "required": "Anghami Url ist erforderlich",
            "invalid": "Bitte fügen Sie eine gültige Url hinzu."
        },
        "bandcamp_url": {
            "required": "Bandcamp Url ist erforderlich",
            "invalid": "Bitte fügen Sie eine gültige Url hinzu."
        },
        "boomplay_url": {
            "required": "Boomplay Url ist erforderlich",
            "invalid": "Bitte fügen Sie eine gültige Url hinzu."
        },
        "iheartradio_url": {
            "required": "iHeartRadio Url ist erforderlich",
            "invalid": "Bitte fügen Sie eine gültige Url hinzu."
        },
        "jiosaavn_url": {
            "required": "JioSaavn Url ist erforderlich",
            "invalid": "Bitte fügen Sie eine gültige Url hinzu."
        },
        "sevendigital_url": {
            "required": "7digital Url ist erforderlich",
            "invalid": "Bitte fügen Sie eine gültige Url hinzu."
        },
        "other_url": {
            "invalid": "Bitte fügen Sie eine gültige Url hinzu."
        },
        "pvTrackName": {
            "required": "Trackname ist erforderlich"
        },
        "pvArtistName": {
            "required": "Künstlername ist erforderlich"
        }
    }
};

export default musicLinksValidationDE;